<template>
  <div
    v-if="messageRequired"
    class="text-center py-1 border"
    :class="$style.noRecord"
  >
    *** No risk indicator(s) found. ***
  </div>
  <div v-else class="text-center py-1 border" :class="$style.noRecord">
    *** No matching record(s) found. ***
  </div>
</template>

<script>
export default {
  props: {
    messageRequired: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';

.noRecord {
  font-size: $size-content-font;
  border-radius: 4px;
}
</style>
